import { StateService } from '@uirouter/angular';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash-es';
import * as d3 from 'd3';
import * as moment from 'moment';

import { AdminService } from '../../../../services/core.admin.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { ReportsDataService } from '../../../../services/core.report-data.service';
import { UserService } from '../../../../services/core.user.service';

@Component({
    selector: 'siteSummaryReportView',
    template: require('./reports.summary.component.html')
})
export class SiteSummaryReportComponent implements OnInit {

    adminOpen = false;
    items: any = false;
    topCommitterstData = [];
    topUsersData = [];
    showDetail = false;
    startDate = '';
    endDate = '';
    yesNo = {
        'Yes': 1,
        'No': 0
    };
    dateRangeOptions = {
        'Daily': 'daily',
        'Weekly': 'weekly',
        'Monthly': 'monthly'
    };
    dateRangeChoice = 'weekly';
    receiveWeeklyEmail = 0;

    topChartOptions = {};
    optionsLoaded = false;

    emailReportPreferenceName = 'site-sum-email';
    periodReportPreferenceName = 'site-sum-period';
    commitsAppliedfilters: any = false;

    topProjectsByActivityData = [];
    topProjectsByCommitsData = [];
    refreshData: any = null;

    constructor(
        private adminService: AdminService, 
        private stateService: StateService, 
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private reportsDataService: ReportsDataService,
        private userService: UserService
    ) { }
    
    ngOnInit() {

        this.topChartOptions = {
            chart: {
                type: 'pieChart',
                height: 360,
                width: 360,
                x: (d) => { return d.key; },
                y: (d) => { return d.y; },
                showLabels: false,
                transitionDuration: 200,
                labelThreshold: 0.01,
                noData: this.gfTranslateService.translate("No Data Available"),
                legendPosition: 'right',
                showLegend: false,
                tooltips: true,
                valueFormat: d3.format('d'),
                labelsOutside: true
            }
        };

        var prefs = [
            this.userService.preference.getPreference(this.emailReportPreferenceName, 0),
            this.userService.preference.getPreference(this.periodReportPreferenceName, this.dateRangeChoice)
        ];

        Promise.all(prefs)
            .then((results) => {
                this.dateRangeChoice = _.get(results, 'dateRange.preferenceValue', 'monthly');
                if (!this.dateRangeChoice?.length) this.dateRangeChoice = 'monthly';
                // Handle whatever tricky values might come from this setting?
                this.receiveWeeklyEmail = _.get(results, 'email.preferenceValue', false) == 1 ? 1 : 0;
                this.optionsLoaded = true;
            }, () => {}
            ).finally(this.loadReportData);

        this.refreshData = this.loadReportData;
    }

    public setEmailReportPreference (newValue) {
        if (newValue == undefined || this.receiveWeeklyEmail == newValue) return false;
        this.userService.preference.setPreference(this.emailReportPreferenceName, newValue)
            .then(() => {
                this.receiveWeeklyEmail = newValue;
            }, (response) => {
                console.log(response);
                this.uiService.message.showWarning(
                    this.gfTranslateService.translate('Sorry, could not update the email preference'),
                    this.gfTranslateService.translate('Report Preferences')
                );
            });
    }

    public setDateRangePreference (newValue) {
        if (newValue == undefined || this.dateRangeChoice == newValue) return false;
        this.userService.preference.setPreference(this.periodReportPreferenceName, newValue)
            .then(() => {
                this.dateRangeChoice = newValue;
            }, (response) => {
                console.log(response);
                this.uiService.message.showWarning(
                    this.gfTranslateService.translate('Sorry, could not update the date range preference'),
                    this.gfTranslateService.translate('Report Preferences')
                );
            }).finally(this.loadReportData);
    }

    getReportUrl = (format) => {
        this.reportsDataService.runReport(format, 'summary');
    };

    setDateRanges() {
        var days = 0;
        switch (this.dateRangeChoice) {
            case 'daily':
                days = 1;
                break;

            case 'monthly':
                days = 30;
                break;

            case 'weekly':
            default:
                days = 7;
                break;
        }

        this.startDate = moment().subtract(days, 'd').format('YYYY-MM-DD');
        this.endDate = moment().format('YYYY-MM-DD');
    }

    loadReportData = () => {
        this.items = false;
        this.setDateRanges();

        this.adminService.report(this.stateService.params)
        .then((response) => {
            this.items = _.get(response, 'items', {});

            this.topProjectsByActivityData = this.reportsDataService.setPieChartData(
                this.getTopProjectsByActivity(_.get(this.items, 'top_projects_by_activity', []))
            );

            this.topUsersData = this.reportsDataService.setPieChartData(
                this.getTopUsersPieChartData(_.get(this.items, 'top_users', []))
            );

            this.topProjectsByCommitsData = this.reportsDataService.setPieChartData(
                this.getTopProjectsByCommitsData(_.get(this.items, 'top_projects_by_commits', []))
            );
        }, () => {
            this.items = false;
            var msg = this.gfTranslateService.translate('There was a problem loading site summary data');
            this.uiService.message.showWarning(msg, 'Data Error');
        });
    }

    getTopProjectsByActivity(items) {
        return _.map(items, (item) => {
            return {
                source: item.projectName + ' (' + item.unixName + ')',
                quantity: item.activity_count
            };
        });
    }

    getTopUsersPieChartData(items) {
        return _.map(items, (item) => {
            return {
                source: item.firstname + ' ' + item.lastname,
                quantity: item.activity_count
            };
        });
    }

    getTopProjectsByCommitsData(items) {
        return _.map(items, (item) => {
            return {
                source: item.projectName + ' (' + item.unixName + ')',
                quantity: item.commit_count
            };
        });
    }
}